import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Button } from '../../../../../components/ui/Button';
import { Input } from '../../../../../components/ui/Input';
interface SaveSnapshotModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (label: string, note: string) => void;
}
export function SaveSnapshotModal({
  isOpen,
  onClose,
  onSave
}: SaveSnapshotModalProps) {
  const [label, setLabel] = useState('');
  const [note, setNote] = useState('');
  if (!isOpen) return null;
  const handleSave = () => {
    onSave(label, note);
    setLabel('');
    setNote('');
    onClose();
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" data-id="element-5148">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden" data-id="element-5149">
        <div className="flex items-center justify-between p-4 border-b border-gray-100" data-id="element-5150">
          <h3 className="font-semibold text-gray-900" data-id="element-5151">Snapshot opslaan</h3>
          <button onClick={onClose} className="p-1 text-gray-400 hover:text-gray-600 rounded-md hover:bg-gray-100 transition-colors" data-id="element-5152">
            <X className="w-5 h-5" data-id="element-5153" />
          </button>
        </div>
        <div className="p-4 space-y-4" data-id="element-5154">
          <div data-id="element-5155">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-5156">
              Label (optioneel)
            </label>
            <Input value={label} onChange={e => setLabel(e.target.value)} placeholder="Bijv. 'Voor T2.2 fix'" className="w-full" data-id="element-5157" />
          </div>
          <div data-id="element-5158">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-5159">
              Notitie (optioneel)
            </label>
            <textarea value={note} onChange={e => setNote(e.target.value)} placeholder="Extra context over deze run..." className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500 min-h-[80px]" data-id="element-5160" />
          </div>
        </div>
        <div className="flex items-center justify-end gap-2 p-4 border-t border-gray-100 bg-gray-50" data-id="element-5161">
          <Button variant="ghost" onClick={onClose} data-id="element-5162">
            Annuleren
          </Button>
          <Button variant="primary" onClick={handleSave} data-id="element-5163">
            Opslaan
          </Button>
        </div>
      </div>
    </div>;
}